import { render } from "./ImageCanvas.vue?vue&type=template&id=e36e24b2&scoped=true"
import script from "./ImageCanvas.vue?vue&type=script&lang=js"
export * from "./ImageCanvas.vue?vue&type=script&lang=js"

import "./ImageCanvas.vue?vue&type=style&index=0&id=e36e24b2&scoped=true&lang=scss"

import exportComponent from "/home/forge/mooz360.co.il/app-src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e36e24b2"]])

export default __exports__